module.exports = __webpack_public_path__ + "media/large_long_echo_hall.1af412f1.wav";